import _ from 'lodash';
import * as RequestResultCases from 'middlewares/api-middleware';
import { COMMS_TRACE_PAGE_SIZE, SEARCH_COMMS_TRACE } from 'omega-rtc/actions/debugging-tools';
import type { SearchCommsTraceParams } from 'omega-rtc/actions/debugging-tools';
import type { CommsTraceUserResult } from 'omega-rtc/views/debugging-tools/types';

export type DebuggingToolsState = {
  users: Record<string, CommsTraceUserResult>;
  page: number;
  pageSize: number;
  lastQuery: SearchCommsTraceParams | null;
  timezone: string;
  hasSearched: boolean;
  notConfigured: boolean;
  lastRequestId: number;
};

export const defaultDebuggingToolsState: DebuggingToolsState = {
  users: {},
  page: 1,
  pageSize: COMMS_TRACE_PAGE_SIZE,
  lastQuery: null,
  timezone: 'UTC',
  hasSearched: false,
  notConfigured: false,
  lastRequestId: 0,
};

const requestIdOf = (action: any): number => _.get(action, 'meta.requestId', 0);

const debuggingToolsReducer = (
  state: DebuggingToolsState = defaultDebuggingToolsState,
  action: any,
): DebuggingToolsState => {
  switch (action.type) {
    case SEARCH_COMMS_TRACE + RequestResultCases.REQUEST:
      return {
        ...state,
        users: {},
        page: _.get(action, 'payload.params.page') || 1,
        pageSize: _.get(action, 'payload.params.pageSize') || state.pageSize,
        lastQuery: _.get(action, 'payload.params') || null,
        notConfigured: false,
        lastRequestId: requestIdOf(action),
      };
    case SEARCH_COMMS_TRACE + RequestResultCases.SUCCESS:
      if (requestIdOf(action) < state.lastRequestId) return state;
      return {
        ...state,
        users: _.get(action.payload, 'users') || {},
        page: _.get(action.payload, 'page') || state.page,
        pageSize: _.get(action.payload, 'pageSize') || state.pageSize,
        timezone: _.get(action.payload, 'timezone') || 'UTC',
        notConfigured: false,
        hasSearched: true,
      };
    case SEARCH_COMMS_TRACE + RequestResultCases.FAILURE:
      if (requestIdOf(action) < state.lastRequestId) return state;
      return {
        ...state,
        users: {},
        notConfigured: Boolean(_.get(action, 'meta.notConfigured')),
        hasSearched: true,
      };
    default:
      return state;
  }
};

export default debuggingToolsReducer;
